// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","checkIcon":"_18U_xD3hiYaBZzyRcvfAKW"};